import React from 'react';
import {Box} from '@mui/material';
import cn from './style.module.scss';
export default function WaldorfContainer({children}: any) {
  return <Box className={cn.waldorfContainer}>{children}</Box>;
}
